export default __webpack_public_path__ + "static/aigenerated-c226f3a7c95924a8b2c2ba703704aa14.svg";